import * as React from 'react';

import { toast } from 'sonner';

import { client } from '@admin/libraries/apollo';
import { useStorageSubscriptionsQuery, useStorageSnapshotCreateMutation, Status } from '@admin/schema';

interface StorageSnapshotButtonProps {
  accountID: string;
}

export const StorageSnapshotButton: React.FC<StorageSnapshotButtonProps> = ({ accountID }) => {
  const { data: storageData } = useStorageSubscriptionsQuery({
    client,
    variables: { accountID },
  });

  const [createSnapshot, { loading: saving }] = useStorageSnapshotCreateMutation({
    client,
    onCompleted: (data) => {
      if (data.storageSnapshotCreate.status === Status.Ok) {
        toast.info('Snapshot Successfully Created!');
      } else {
        toast.error(data.storageSnapshotCreate.error ?? 'An error occurred while creating the snapshot.');
      }
    },
    onError: (error) => {
      toast.error(error.message ?? 'An unknown error occurred. Please contact technical support.');
    },
  });

  const inventoryMetrics = storageData?.inventoryMetrics;
  const hasUnsizedItems = Boolean(inventoryMetrics?.unsizedItemsCount && inventoryMetrics.unsizedItemsCount > 0);

  const handleSaveSnapshot = () => {
    if (saving || !inventoryMetrics || hasUnsizedItems) {
      return;
    }

    createSnapshot({
      variables: { accountID },
    });
  };

  const isDisabled = saving || !inventoryMetrics || hasUnsizedItems;

  return (
    <button className="btn btn-info" onClick={handleSaveSnapshot} disabled={isDisabled}>
      Save Storage Snapshot
    </button>
  );
};
